<div class="flex flex-col !gap-5">
  <div class="header flex flex-row items-center justify-between">
    <div class="flex flex-row items-center">
      <ion-icon
        [src]="ads ? '../../../assets/icon/attention-icon-orange.svg' : '../../../assets/icon/attention-icon.svg'"
      ></ion-icon>
      <h1>{{ ads ? '¡ATENCIÓN!' : 'COMUNICACIONES COMERCIALES' }}</h1>
    </div>

    <ion-button fill="clear" class="close" (click)="close()">
      <ion-icon src="../../../assets/icon/cross.svg"></ion-icon>
    </ion-button>
  </div>

  <hr />

  <h2>
    {{
      ads
        ? 'Vas a cancelar tu suscripción a nuestras comunicaciones comerciales 🥺'
        : 'Suscríbete GRATIS para estar al día de nuestras novedades 😎'
    }}
  </h2>

  <div *ngIf="ads" class="message">
    La cancelación de tu suscripción a nuestras comunicaciones comerciales se efectuará de forma
    <span class="font-bold">automática</span> al hacer click en el botón de
    <span class="font-bold">“Cancelar mi suscripción”</span>. <br /><br />
    Por favor, ten en cuenta que al realizar esta acción dejarás de recibir nuestros emails comerciales y te perderás
    nuestras novedades.
    <br /><br />
    Si lo deseas, podrás volver a suscribirte desde la pantalla de “Mi perfil”.
  </div>
  <div *ngIf="!ads" class="message">
    Te enviaremos emails de vez en cuando anunciando nuestras novedades. <br />Te prometo que no te haremos perder el
    tiempo.
  </div>

  <hr />

  <div class="buttons flex flex-row items-center justify-end gap-2.5">
    <button class="gray" (click)="close()">Cancelar</button>
    <button id="open-toast" (click)="onCloseAction()" [ngClass]="{ subscribe: !ads }">
      {{ ads ? 'Cancelar mi suscripción' : 'Quiero suscribirme' }}
    </button>
  </div>
</div>
